import React from 'react';
import DeleteObject from '../../../common/poppers/DeleteObject';
import ModifyProject from './ModifyProject';
import ProjectRow from './ProjectRow';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { NavLink } from "react-router-dom";

export const projectActionItems = [
    {
        isnavlink: true,
        title: "Részletek megnyitása",
        icon: <ListAltIcon fontSize="small" color="primary" />,
        navlink: (props) => <NavLink to={`/projectdetail/${props?.row?.privateId}`}>
            Részletek megnyitása
        </NavLink >,
    },
    {
        dataDialog: "modify-dialog",
        title: "Módosít",
        dialogTitle: "Projekt módosítása",
        icon: <EditIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <ModifyProject  {...props} close={close} />
    },
    // {
    //     dataDialog: "close-dialog",
    //     title: "Lezárás",
    //     dialogTitle: "Biztos hogy le szeretnéd zárni?",
    //     icon: <CancelOutlinedIcon fontSize="small" color="primary" />,
    //     actionComponent: (props, close) => <CloseObject {...props} close={close} path={'/api/project/close'} datePickerlabel={'Projekt vége'} />
    // },
    {
        divider: true,
    },
    {
        dataDialog: "delete-dialog",
        title: "Törlés",
        dialogTitle: "Projekt törlése",
        icon: <DeleteIcon fontSize="small" color="primary" />,
        actionComponent: (props, close) => <DeleteObject {...props} close={close} path={'/api/project'} confirm={"Biztos hogy törölni szeretnéd?"} comp={<ProjectRow {...props} />} />
    }
]